@use "../../styles/breakpoint.module" as *;

.root {
    padding-top: var(--spacer-80);
}

.list {
    --mobile-item-width: 85vw;
    --end-gap: 50vw;

    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    gap: var(--spacer-104);
    padding-left: 80vw;
    will-change: transform;

    &::after {
        content: "";
        flex: 0 0 calc(var(--end-gap) - var(--spacer-104));
    }

    @media ($below-mobile) {
        --end-gap: calc((100vw - var(--mobile-item-width)) / 2);

        padding-left: var(--end-gap);
    }
}

.listItem {
    transition: filter 0.4s;
}

.activeListItem {
    composes: listItem;
    filter: grayscale(0);
}

.inactiveListItem {
    composes: listItem;
    filter: grayscale(1);
}
